/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const HeartbeatIconOutline = createIcon({
  displayName: 'HeartbeatIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,4.925c0.775,-0.907 2.116,-1.925 4.158,-1.925c3.571,0 5.967,3.352 5.967,6.474c0,6.526 -8.125,11.526 -10.125,11.526c-2,0 -10.125,-5 -10.125,-11.526c0,-3.122 2.396,-6.474 5.967,-6.474c2.042,0 3.383,1.018 4.158,1.925Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7,11.5h2.222l1.667,-2.5l2.222,5l1.667,-2.5h2.222"
        ></path>
      </g>
    </>
  ),
})

const HeartbeatIconTwoTone = createIcon({
  displayName: 'HeartbeatIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <Box as="path" d="M0,0h24v24h-24Z"></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,4.925c0.775,-0.907 2.116,-1.925 4.158,-1.925c3.571,0 5.967,3.352 5.967,6.474c0,6.526 -8.125,11.526 -10.125,11.526c-2,0 -10.125,-5 -10.125,-11.526c0,-3.122 2.396,-6.474 5.967,-6.474c2.042,0 3.383,1.018 4.158,1.925Z"
        ></Box>
        <Box
          as="path"
          stroke="light"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7,11.5h2.222l1.667,-2.5l2.222,5l1.667,-2.5h2.222"
        ></Box>
      </g>
    </>
  ),
})

const Heartbeat: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={HeartbeatIconTwoTone} {...props} />
    default:
      return <CustomIcon as={HeartbeatIconOutline} {...props} />
  }
}

export default memo(Heartbeat)
